import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import SectionCard from '../../../positionTemplate/components/SectionCard';
import AutoSaveTextField from '../AutoSaveTextField';
import SectionTitle from '../SectionTitle';

const RATE_FIELDS = [
  'payRateReg',
  'payRateOT',
  'payRateDT',
  'billRateReg',
  'billRateOT',
  'billRateDT',
];

const gridSx = {
  display: 'grid',
  gap: '16px',
  gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, minmax(0, 1fr))' },
  padding: '8px 0 16px',
};

const toCurrencyInput = (value) => (typeof value === 'number' ? value.toFixed(2) : '');

const PayRatesCard = ({ positionTemplate, saveField, getStatus }) => {
  const intl = useIntl();
  const t = (id, values) => intl.formatMessage({ id }, values);

  const validateRate = (value) =>
    /^\d+(\.\d{1,2})?$/.test(value.trim()) && Number(value) > 0
      ? null
      : t('pt.detail.payRates.invalid');

  return (
    <SectionCard header={<SectionTitle>{t('pt.detail.payRates.title')}</SectionTitle>}>
      <Box sx={gridSx}>
        {RATE_FIELDS.map((field) => (
          <AutoSaveTextField
            key={field}
            id={`pt-detail-${field}`}
            label={t(`pt.detail.payRates.${field}`)}
            value={toCurrencyInput(positionTemplate[field])}
            status={getStatus(field)}
            validate={validateRate}
            startAdornment="$"
            onSave={(value) => {
              const rate = Number(value);
              saveField({ key: field, fields: { [field]: rate }, patch: { [field]: rate } });
            }}
          />
        ))}
      </Box>
    </SectionCard>
  );
};

PayRatesCard.propTypes = {
  positionTemplate: PropTypes.shape({
    payRateReg: PropTypes.number,
    payRateOT: PropTypes.number,
    payRateDT: PropTypes.number,
    billRateReg: PropTypes.number,
    billRateOT: PropTypes.number,
    billRateDT: PropTypes.number,
  }).isRequired,
  saveField: PropTypes.func.isRequired,
  getStatus: PropTypes.func.isRequired,
};

export default PayRatesCard;
